const apiVersion = (typeof FORCE_API_VERSION === "string") && FORCE_API_VERSION || "v1.2";
const rootUri = "";
const getApiUri = _rootUri => _rootUri + "/api/" + apiVersion;
const apiUri = getApiUri(rootUri);

module.exports = {
  rootUri,
  apiUri,
  getApiUri,
};



// WEBPACK FOOTER //
// ./config/serverConfig.js